import React, {Component} from 'react'
import {browserName, osName, osVersion} from 'react-device-detect'
import SplashTemplate from 'shared/components/SplashTemplate'

class NotSupported extends Component {
    render() {
        return (
            <SplashTemplate>
                <div>
                    <h1 className="spark-splash-screen__heading">{osName} {osVersion} ({browserName})</h1>
                    <h3 className="spark-splash-screen__heading">We're very sorry but this product doesn't support mobile devices.</h3>
                </div>
            </SplashTemplate>
        )
    }
}

export default NotSupported;


// WEBPACK FOOTER //
// ./src/shared/components/ErrorPages/NotSupported.js